ALLOWED_CONTROLLER = 'locations'
ALLOWED_ACTIONS = ['ui_nodes']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  $('#location-ui-nodes').dataTable
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    iDisplayLength: 25
    sAjaxSource: $('#location-ui-nodes').data('source')
    order: [ [ 0, "desc" ] ]
    aoColumnDefs: [{ orderable: false, targets: "no-sort" }]

$(document).ready(ready)
